module.exports = __webpack_public_path__ + "img/land_main_text_en.0fb07551.svg";